import type {FC} from "react";

import {setNumericValue} from "../../utils/app-utils";
import Tooltip from "../common/Tooltip";
import type {NumericSetterFunc} from "../wizard.types";

/**
 * Wizard related numeric value form field component.
 */
export const NumericFormField: FC<{
  labelText: string,
  testId: string,
  tooltip?: string
  value: number | undefined,
  onChange: NumericSetterFunc
}> = ({labelText, testId, tooltip, value, onChange}) =>
  //
  (
    <>
      <label>{labelText}</label>
      {tooltip && <Tooltip title={tooltip}/>}
      <input data-testid={testId} type='text' className='form-control mb-3' name='' placeholder=''
             value={value ?? ''} onChange={(e) => {
        setNumericValue(onChange, e.target.value)
      }}/>
    </>
  )
